import { Provider } from "@supabase/supabase-js";
import {
  AuthenticationServiceType,
  AuthValidationError,
} from "djinn-components";
import { supabase } from "./initSupabase";
import { toast } from "react-toastify";

const redirectTo = "/";

const authenticationService: AuthenticationServiceType = {
  getUser: async () => {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) return null;
    return {
      id: user.id as string,
      name: user.user_metadata?.name ?? "",
      email: user.email as string,
      avatar: null,
      metadata: {
        ...user.user_metadata,
      },
    };
  },
  emailLogin: async (email, password) => {
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      throw new AuthValidationError(error.message, {});
    }
  },
  magicLinkLogin: async (email) => {
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: redirectTo,
      },
    });
    if (error) {
      throw new AuthValidationError(error.message, {});
    }
  },
  getRemembered: async () => undefined,
  emailRegister: async (name, email, password, passwordConfirmation) => {
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: redirectTo,
        data: {
          name,
        },
      },
    });

    if (error) {
      throw new AuthValidationError(error.message, {});
    }

    toast("Please check your inbox for registration verification email.", {
      type: "success",
    });
  },
  socialLoginRegister: async (provider) => {
    const authProvider = provider as Provider;
    const { error } = await supabase.auth.signInWithOAuth({
      provider: authProvider,
      options: {
        redirectTo,
      },
    });
    if (error) {
      throw new AuthValidationError(error.message, {});
    }
  },
  forgotPassword: async (email) => {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo,
    });

    if (error) {
      throw new AuthValidationError(error.message, {});
    }
  },
  resetPassword: async (password, passwordConfirmation) => {
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      throw new AuthValidationError(error.message, {});
    }
  },
};

export default authenticationService;
